import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import DaithPiercingImage from '../../Assets/Piercing Services/daith piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function DaithPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Daith Piercing UAE | 150-200 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Daith Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Daith Piercing 150-200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={DaithPiercingImage} alt="Daith Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Daith Piercing</h3>

          <p>
            Enhance your ear styling with our professional daith piercing services in the UAE, available at an affordable price range of 150–200 AED. Daith piercing is a stylish and distinctive cartilage piercing placed through the innermost fold of the ear, making it one of the most unique and eye-catching piercing options available. Its hidden yet elegant placement creates a subtle statement that stands out in a sophisticated way, making it a popular choice for individuals who want a refined and modern look. Whether you prefer a sleek hoop or a decorative ring, our expert specialists ensure precise placement for a comfortable and visually appealing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each daith piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Due to its placement in the inner cartilage, daith piercing requires skill and expertise, and our experienced specialists are trained to deliver accurate results while minimizing discomfort.
          </p>

          <p>
            Daith piercing is ideal for those who want a unique and stylish ear design that differs from traditional piercings. Its location makes it perfect for creating a curated and layered ear look when paired with other piercings such as helix, tragus, or lobe. Our specialists take the time to understand your preferences and guide you in selecting the best jewelry style and placement to match your personal aesthetic. This personalized approach ensures that your piercing enhances your overall appearance while maintaining comfort.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient even for those with busy schedules. Our team uses advanced techniques designed to reduce pain and promote faster healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that inner ear piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is an essential part of maintaining your daith piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your daith piercing will heal effectively and remain a stylish and long-lasting addition to your look.
          </p>

          <p>
            Our daith piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted daith piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a unique and elegant look effortlessly. Book your daith piercing appointment today and elevate your ear styling with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Daith Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default DaithPiercing;